/** A small "Beta" pill shown next to the product name in the header. */
export function BetaBadge() {
  return (
    <span
      className="rounded bg-amber-100 px-1.5 py-0.5 text-[0.625rem] font-semibold tracking-wide text-amber-700 uppercase dark:bg-amber-500/15 dark:text-amber-400"
      title="MarkRoom is in beta — your feedback shapes it."
    >
      Beta
    </span>
  );
}
